<template>
  <div class="aside-icon-menu" @transitionstart="handleTransitionStart" @transitionend="handleTransitionEnd">
    <div class="menu-list" :style="menuListStyle">
      <div
        v-for="(menu, key) in menuList"
        class="menu-item"
        :key="key"
        :class="currentMenu === menu && 'is-active'"
        @click="onMenuClick(menu)"
      >
        <i class="menu-icon" :class="menu.icon"></i>
        <span class="menu-label">{{ $t(`${i18nKeyPrefix}.menu.${key}`) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import scrollbarWidth from 'element-ui/src/utils/scrollbar-width'
import _ from 'lodash'
import { mixedRouterPush } from '@/router/routes'

export default {
  data () {
    return {
      i18nKeyPrefix: 'admin.layout.newLayout',
      menuListStyle: null,
      currentMenu: null
    }
  },
  computed: {
    menuList () {
      return this.$parent.menuList || []
    }
  },
  created () {

  },
  mounted () {
    const barWidth = scrollbarWidth()
    this.menuListStyle = {
      marginRight: `-${barWidth}px`,
      marginBottom: `-${barWidth}px`
    }
  },
  methods: {
    handleTransitionStart (event) {
      const el = event.currentTarget
      el.classList.add('moving')
    },
    handleTransitionEnd (event) {
      const el = event.currentTarget
      el.classList.remove('moving')
      const hoverElList = el.parentElement.querySelectorAll(':hover')
      const hover = _.some(hoverElList, hoverEl => hoverEl === el)
      if (hover) {
        el.classList.add('closing')
      } else {
        el.classList.remove('closing')
      }
    },
    onMenuClick (menu) {
      if (menu.path) {
        window.location.href = menu.path
        return
      }
      if (menu.route) {
        mixedRouterPush(menu.route.path)
      }
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler () {
        let route = this.$route
        let currentMenu = null
        let found = false
        while (route) {
          found = _.some(this.menuList, menu => {
            currentMenu = menu
            if (menu.route) {
              return route.meta === menu.route.meta
            } else {
              return route.path === menu.path
            }
          })
          if (found) {
            break
          } else {
            route = route.meta?._parent
          }
        }
        if (found) {
          this.currentMenu = currentMenu
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$main-color: #666666;

.aside-icon-menu {
  width: 56px;
  height: 100%;
  padding-top: 52px;
  background: $main-color;
  transition: width .3s ease-in-out;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;

  .menu-list {
    height: 100%;
    overflow: hidden scroll;
    transition: width .3s ease-in-out;

    .menu-item {
      margin: 20px 0;
      padding: 20px 20px 20px 10px;
      border-radius: 2px;
      line-height: 16px;
      color: #ffffff;
      border-left: 10px solid transparent;
      word-break: keep-all;
      white-space: nowrap;
      overflow: hidden;
      cursor: pointer;

      .menu-icon {
        display: inline-block;
        width: 16px;
        font-size: 16px;
        vertical-align: middle;
        text-align: center;
      }

      .icona-ChangeEmail2 {
        font-size: 13px;
      }

      .menu-label {
        display: none;
        margin-left: 12px;
        vertical-align: middle;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: 500;
        font-size: 14px;
      }

      &.is-active, &:hover {
        color: $main-color;
        background: #fff;
      }
    }

  }

  &.closing {
    .menu-list {
      .menu-item {
        text-align: left;

        .menu-label {
          display: inline;
        }
      }
    }
  }

  &:hover {
    width: 170px;

    .menu-list {
      .menu-item {
        text-align: left;
        margin-right: 10px;

        &.is-active, &:hover {
          margin-left: 0;
          border-left-color: #0096cc;
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }

        .menu-label {
          display: inline;
        }
      }
    }
  }
}
</style>
